// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download_file-name_lcAmH {
  font-family: monospace;
  -webkit-user-select: text;
     -moz-user-select: text;
      -ms-user-select: text;
          user-select: text;
  word-wrap: break-word;
}
.download_file-name_lcAmH::before {
  content: '"';
}
.download_file-name_lcAmH::after {
  content: '"';
}
.download_name_dWPBO {
}
.download_dot_DZ5vK {
}
.download_extension_EQoDO {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/download.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;AACA;AACA;AACA;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".file-name {\n  font-family: monospace;\n  -webkit-user-select: text;\n     -moz-user-select: text;\n      -ms-user-select: text;\n          user-select: text;\n  word-wrap: break-word;\n}\n.file-name::before {\n  content: '\"';\n}\n.file-name::after {\n  content: '\"';\n}\n.name {\n}\n.dot {\n}\n.extension {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file-name": `download_file-name_lcAmH`,
	"fileName": `download_file-name_lcAmH`,
	"name": `download_name_dWPBO`,
	"dot": `download_dot_DZ5vK`,
	"extension": `download_extension_EQoDO`
};
export default ___CSS_LOADER_EXPORT___;
